import { render, staticRenderFns } from "./BaseG3RowDetail.vue?vue&type=template&id=1ad16c40&scoped=true"
import script from "./BaseG3RowDetail.vue?vue&type=script&lang=js"
export * from "./BaseG3RowDetail.vue?vue&type=script&lang=js"
import style0 from "./BaseG3RowDetail.vue?vue&type=style&index=0&id=1ad16c40&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad16c40",
  null
  
)

export default component.exports